module.exports = __webpack_public_path__ + "logo-orkla-tagline-se-white-ad6a3ce3cb45d4bac042c099e47ca067.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-se-white.svg
// module id = 70
// module chunks = 0